import { render } from "./VendorDetailsOpportunitiesTab.vue?vue&type=template&id=3a484d33"
import script from "./VendorDetailsOpportunitiesTab.vue?vue&type=script&lang=js"
export * from "./VendorDetailsOpportunitiesTab.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__